var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "30px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索材料...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchRawMaterial
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('Select', {
    staticStyle: {
      "width": "25%",
      "margin-right": "20px"
    },
    attrs: {
      "placeholder": "禁用显示",
      "label-in-value": ""
    },
    on: {
      "on-change": _vm.choseIsInvalid
    },
    model: {
      value: _vm.isInvalid,
      callback: function ($$v) {
        _vm.isInvalid = $$v;
      },
      expression: "isInvalid"
    }
  }, _vm._l(_vm.isInvalidList, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('div', {
    staticClass: "page-wrap"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    attrs: {
      "total": _vm.totalRows,
      "page-size": 50,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadCaclPurchase
    }
  })], 1), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openCreateMaterialDrawer();
      }
    }
  }, [_vm._v("新增原材料")])], 1)]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "loading": _vm.tableLoading,
      "columns": _vm.columns,
      "data": _vm.latestPurchases,
      "height": _vm.tableHeight
    }
  })], 1), _c('EditRawMaterialDrawer', {
    ref: "EditRawMaterialDrawer"
  }), _c('MaterialPurchaseDrawer', {
    ref: "MaterialPurchaseDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }